module.exports = __webpack_public_path__ + "img/2-2.ac6042bc.png";